<!-- eslint-disable prettier/prettier -->
<template>
  <div>
    <rabbey-toolbox
      :filterables="true"
      @filter-search="filterSearch"
      style="margin-top: 20px; margin-bottom: 20px"
      @change="handleFilters"
    >
      <div class="mr-5">
        <el-select
          clearable
          filterable
          default-first-option
          v-model="ProductId"
          placeholder="Producto"
          size="mini"
          style="margin-left: 5px"
          @change="handleFilters"
        >
          <el-option
            v-for="(item, index) in productList"
            :key="index"
            :label="item.Description"
            :value="item.Id"
          ></el-option>
        </el-select>
      </div>
      <div class="mr-5">
        <el-select
          size="mini"
          placeholder="Tecnico Asignado"
          v-model="TechnicianId"
          filterable
          clearable
          @change="handleTechnicianChange"
        >
          <el-option
            v-for="(item, index) in technicians"
            :key="index"
            :value="item.value"
            :label="item.label"
          />
        </el-select>

        <!-- <el-select
            v-model="dialog.technical"
            clearable
            placeholder="Tecnico"
            filterable
          >
            <el-option
              v-for="item in technicians"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
      </div>
      <div class="mr-5">
        <el-select
          size="mini"
          placeholder="Servicio al Cliente"
          v-model="Customer_filter"
          filterable
          clearable
          @change="handleFilters"
        >
          <el-option
            v-for="(item, index) in customerList"
            :key="index"
            :value="item.Code"
            :label="item.FullName"
          />
        </el-select>
      </div>
      <div class="mr-5">
        <el-select
          size="mini"
          placeholder="Cliente"
          v-model="CustomersFilter"
          filterable
          clearable
          @change="handleFilters"
        >
          <el-option
            v-for="(item, index) in list_customersSelect"
            :key="index"
            :value="item.ClientCode"
            :label="item.Name"
          />
        </el-select>
      </div>

      <div class="mr-5">
        <el-date-picker
          v-model="filterDate"
          unlink-panels
          type="daterange"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          value-format="yyyy-MM-dd"
          size="mini"
          @change="handleFilterDate"
        >
        </el-date-picker>
      </div>

      <div class="mr-5">
        <RequestTypeSelector
          :type.sync="requestType"
          @change="onChangeCustomerService"
        />
      </div>
    </rabbey-toolbox>

    <dialog-new-interaction-form
      :CustomerData="CustomerData"
      ref="dialogNewInteraction"
    />

    <cardcountRequest
      :myRequestNewCount="myRequestInNewCount"
      :myRequestAssingCount="myRequestInAssingCount"
      :myRequestInProgressCount="myRequestInProgressCount"
      :myRequestInClosedCount="myRequestInClosed"
      :myRequestUpdateInventoryCount="myRequestUpdateInventoryCount"
      :myRequestUpdateContractCount="myRequestUpdateContractCount"
      :myRequestValidateCount="myRequestValidateCount"
      :myRequestQualifyCount="myRequestQualifyCount"
      :myRequestCancellCount="myRequestInCancelCount"
      :myRequestCompletedCount="myRequestInCompleteCount"
    ></cardcountRequest>
    <!-- :myStarsAllCount="myStarAllCount"
    <el-button type="danger"
          size="mini"
          @click="StarAllCount()"></el-button>
    -->
    <!---->
    <el-row>
      <el-col :span="24">
        <el-tabs
          ref="tabs"
          type="border-card"
          :before-leave="onTabSwitch"
          v-model="defaultTabActive"
          :activeName="activeName"
        >
          <el-tab-pane label="Nuevo" name="0">
            <rabbey-table2
              v-if="defaultTabActive === '0'"
              ref="table_0"
              index-url="/api/serviceRequests"
              key-search="Id"
              :filter-list="searchResult"
              :columns="columns"
              :actions="actions[0]"
              :default-params="getParams"
              :search="search"
              @rtable-push-action="handleCommand"
              v-loading="searchLoading"
            />
          </el-tab-pane>
          <!-- <el-tab-pane label="Asignada" name="2">
            <rabbey-table2
              v-if="defaultTabActive === '2'"
              ref="table_2"
              index-url="/api/serviceRequests"
              key-search="Id"
              :filter-list="searchResult"
              :columns="columns"
              :actions="actions[2]"
              :default-params="getParams"
              :search="search"
              @rtable-push-action="handleCommand"
            />
          </el-tab-pane> -->
          <el-tab-pane label="En Progreso" name="3">
            <rabbey-table2
              v-if="defaultTabActive === '3'"
              ref="table_3"
              index-url="/api/serviceRequests"
              key-search="Id"
              :filter-list="searchResult"
              :columns="columns"
              :actions="actions[3]"
              :default-params="getParams"
              :search="search"
              @rtable-push-action="handleCommand"
              v-loading="searchLoading"
            />
          </el-tab-pane>
          <el-tab-pane label="Cerradas" name="4">
            <rabbey-table2
              v-if="defaultTabActive === '4'"
              ref="table_4"
              index-url="/api/serviceRequests"
              key-search="Id"
              :filter-list="searchResult"
              :columns="columns"
              :actions="actions[4]"
              :default-params="getParams"
              :search="search"
              @rtable-push-action="handleCommand"
              v-loading="searchLoading"
            />
          </el-tab-pane>
          <el-tab-pane label="Pendiente por Validar" name="17">
            <rabbey-table2
              v-if="defaultTabActive === '17'"
              ref="table_17"
              index-url="/api/serviceRequests"
              key-search="Id"
              :filter-list="searchResult"
              :columns="columns"
              :actions="actions[17]"
              :default-params="getParams"
              :search="search"
              @rtable-push-action="handleCommand"
              v-loading="searchLoading"
            />
          </el-tab-pane>
          <el-tab-pane label="Revisión de Contrato" name="10">
            <rabbey-table2
              v-if="defaultTabActive === '10'"
              ref="table_10"
              index-url="/api/serviceRequests"
              key-search="Id"
              :filter-list="searchResult"
              :columns="columns"
              :default-params="getParams"
              :search="search"
              :actions="actions[10]"
              @rtable-push-action="handleCommand"
              v-loading="searchLoading"
            />
          </el-tab-pane>
          <el-tab-pane label="Actualizar Inventario" name="12">
            <rabbey-table2
              v-if="defaultTabActive === '12'"
              ref="table_12"
              index-url="/api/serviceRequests"
              key-search="Id"
              :filter-list="searchResult"
              :columns="columns"
              :actions="actions[12]"
              :default-params="getParams"
              :search="search"
              @rtable-push-action="handleCommand"
              v-loading="searchLoading"
            />
          </el-tab-pane>
          <el-tab-pane label="Validadas" name="5">
            <rabbey-table2
              v-if="defaultTabActive === '5'"
              ref="table_5"
              index-url="/api/serviceRequests"
              key-search="Id"
              :filter-list="searchResult"
              :columns="columns"
              :actions="actions[5]"
              :default-params="getParams"
              :search="search"
              @rtable-push-action="handleCommand"
              v-loading="searchLoading"
            />
          </el-tab-pane>
          <el-tab-pane label="Canceladas" name="9">
            <rabbey-table2
              v-if="defaultTabActive === '9'"
              ref="table_9"
              index-url="/api/serviceRequests"
              key-search="Id"
              :filter-list="searchResult"
              :columns="columns"
              :actions="actions[9]"
              :default-params="getParams"
              :search="search"
              @rtable-push-action="handleCommand"
              v-loading="searchLoading"
            />
          </el-tab-pane>
          <el-tab-pane label="Completadas" name="14">
            <rabbey-table2
              v-if="defaultTabActive === '14'"
              ref="table_14"
              index-url="/api/serviceRequests"
              key-search="Id"
              :filter-list="searchResult"
              :columns="columns"
              :actions="actions[14]"
              :default-params="getParams"
              :search="search"
              @rtable-push-action="handleCommand"
              v-loading="searchLoading"
            />
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <coordinate-installation
      ref="coordinate_installation"
      @success="refreshTableSuccess"
    />
    <register-diveces ref="register_diveces" />
    <request-form ref="form" />
    <record-rating ref="record_rating" @rating-success="refreshTableSuccess" />
    <el-dialog
      :title="dialog.title"
      :visible.sync="dialog.visible"
      width="55%"
      ref="dialogRef"
      :before-close="handleClose"
    >
      <h3>Técnico Responsable</h3>
      <el-form
        :model="dialog"
        :rules="rules[dialog.type]"
        ref="dialogForm"
        label-width="120px"
        label-position="top"
      >
        <el-form-item
          label="Tecnico"
          prop="technical"
          v-if="['assign-technician', 'reallocate'].includes(dialog.type)"
        >
          <el-select
            v-model="dialog.technical"
            clearable
            placeholder="Tecnico"
            filterable
            @change="handleTechnicianChange"
          >
            <el-option
              v-for="(item, index) in technicians"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="Comentario del Log"
          prop="comment"
          v-if="dialog.type !== 'none'"
        >
          <el-input
            type="textarea"
            :rows="2"
            :placeholder="dialog.placeholder"
            v-model="dialog.comment"
          >
          </el-input>
        </el-form-item>

        <el-form-item
          label="Diagnóstico"
          prop="diagnostic"
          v-if="dialog.type == 'close'"
        >
          <el-input
            type="textbox"
            :placeholder="dialog.placeholder"
            v-model="dialog.diagnostic"
          >
          </el-input>
        </el-form-item>

        <el-form-item
          label="Solución Definitiva"
          prop="solution"
          v-if="dialog.type == 'close'"
        >
          <el-input
            type="textarea"
            :rows="2"
            :placeholder="dialog.placeholder"
            v-model="dialog.solution"
          >
          </el-input>
        </el-form-item>

        <el-form-item
          v-if="
            (dialog.type == 'close' &&
              dialog.TipoProducto == 2 &&
              dialog.TipoSolicitud == 2) ||
            (dialog.TipoProducto == 2 && dialog.TipoSolicitud == 3) ||
            (dialog.TipoProducto == 2 && dialog.TipoSolicitud == 12)
          "
        >
          <el-select v-model="LineaContrato" filterable placeholder="Select">
            <el-option
              v-for="item in data"
              :key="item.LineaNo"
              :label="item.Descripcion"
              :value="item.LineaNo"
            >
            </el-option>
          </el-select>
          <el-input
            class="firstinpunt"
            placeholder="Id Tracker"
            v-model="Tracker"
          >
          </el-input>
          <el-input
            class="firstinpunt"
            placeholder="Id Dispositivo"
            v-model="Seriall"
          >
          </el-input>

          <el-form :model="ruleForm" :rules="rules2" ref="ruleForm">
            <el-form-item prop="Telefono">
              <el-input
                class="firstinpunt"
                placeholder="Telefono"
                v-model="ruleForm.Telefono"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </el-form-item>
      </el-form>

      <AssignTechnicianInstalationForm
        v-show="
          (dialog.type == 'assign-technician' || dialog.type == 'reallocate') &&
          requestRowData.ServiceRequestType.Description &&
          requestRowData.ServiceRequestType.Description == 'Instalación'
        "
        ref="InstalationFormData"
        style="margin-top: 20px"
        :rowData="requestRowData"
        :SelectedTechnician="selectedTechnician"
        :Tab="dialog.type"
      />

      <AssignTechnicianUninstallationForm
        v-show="
          (dialog.type == 'assign-technician' || dialog.type == 'reallocate') &&
          UninstallAndDeviceChangeValidator
        "
        ref="UninstallationOrDeviceChangeFormData"
        style="margin-top: 20px"
        :rowData="requestRowData"
        :SelectedTechnician="selectedTechnician"
        :Tab="dialog.type"
      />

      <span slot="footer" class="dialog-footer">
        <el-button
          type="danger"
          size="mini"
          @click="cancelDialog('dialogForm')"
        >
          Cancelar</el-button
        >
        <el-button
          type="primary"
          size="mini"
          @click="confirmDialog('dialogForm')"
          v-loading="confirmLoading"
          >Confirmar</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="Validar Contrato"
      :visible.sync="contractDialog"
      :before-close="clearContractDialog"
    >
      <h3>Datos del Cliente</h3>
      <el-row>
        <el-col :span="12">
          <el-row>
            <span class="demo-input-label">Cliente</span>
            <el-input
              :disabled="true"
              style="width: 300px; margin-left: 30px"
              v-model="ServiceRequestData.Customer.Name"
            />
          </el-row>
          <el-row>
            <span class="demo-input-label">Tel Cliente</span>
            <el-input
              :disabled="true"
              style="width: 150px; margin-left: 30px"
              v-model="ServiceRequestData.Customer.PhoneNumber"
            />
          </el-row>
          <el-row>
            <span class="demo-input-label">Dirección Cliente</span>
            <el-input
              :disabled="true"
              type="textarea"
              autosize
              style="width: 400px; margin-left: 30px"
              v-model="ServiceRequestData.Customer.Address"
            />
          </el-row>
        </el-col>

        <el-col :span="12">
          <el-row>
            <span class="demo-input-label">Contacto</span>
            <el-input
              :disabled="true"
              style="width: 300px; margin-left: 30px"
              v-model="ClientsContactData.Name"
            />
          </el-row>
          <el-row>
            <span class="demo-input-label">Tel Contacto</span>
            <el-input
              :disabled="true"
              style="width: 150px; margin-left: 30px"
              v-model="ClientsContactData.PhoneNumber"
            />
          </el-row>
          <el-row>
            <span class="demo-input-label">Cel Contacto</span>
            <el-input
              :disabled="true"
              style="width: 150px; margin-left: 30px"
              v-model="ClientsContactData.MobilePhoneNumber"
            />
          </el-row>
        </el-col>
      </el-row>

      <h3 style="margin-top: 50px">Datos de la Solicitud</h3>
      <el-row>
        <span class="demo-input-label">No. Solicitud</span>
        <el-input
          :disabled="true"
          style="width: 150px; margin-left: 30px"
          v-model="ServiceRequestData.Id"
        />
      </el-row>

      <el-row>
        <span class="demo-input-label">Tipo de Solicitud</span>
        <el-input
          :disabled="true"
          style="width: 150px; margin-left: 30px"
          v-model="ServiceRequestData.ServiceRequestType.Description"
        />
      </el-row>

      <el-row>
        <span class="demo-input-label">Producto</span>
        <el-input
          :disabled="true"
          style="width: 150px; margin-left: 30px"
          v-model="ServiceRequestData.Product.Description"
        />
      </el-row>

      <el-row>
        <span class="demo-input-label">Descripción</span>
        <el-input
          :disabled="true"
          type="textarea"
          autosize
          style="width: 80%; margin-left: 30px"
          v-model="ServiceRequestData.Comments"
        />
      </el-row>

      <h3 style="margin-top: 30px">Selección de Contrato</h3>

      <el-form>
        <el-form-item label="Número de Contrato">
          <el-select
            v-model="ClientContractCode"
            placeholder="Número de Contrato"
            clearable
            filterable
            v-loading="contractLoading"
            @change="LineContractSelect"
          >
            <el-option
              v-for="contract in contractList"
              :key="contract.ContractCode"
              :value="contract.ContractCode"
              :label="contract.ContractCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <el-button
        type="primary"
        size="mini"
        v-loading="savingLoading"
        @click="handleContractSave"
      >
        Guardar
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import RequestForm from "@/views/modules/technical_support/requests/RequestForm.vue";
import CoordinateInstallation from "@/components/requests/CoordinateInstallation.vue";
import RegisterDevices from "@/components/requests/RegisterDevices.vue";
import RecordRating from "@/components/requests/RecordRating.vue";
import cardcountRequest from "@/components/requests/CardsExternalRequests.vue";
import RequestTypeSelector from "@/components/Company/RequestTypeSelector.vue";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import { COLUMNAS, ACTIONS, RULES, COMMON_DIALOG } from "./requests";
//import { mapState, mapMutations, mapActions } from "vuex";
import { PAGINATION_DEFAULT } from "@/const";
import { formatArrayToElSelect, formatDate, formatQty } from "@/utils";
// import { technicians } from "@/views/modules/technical_support/requests/requests";
import AssignTechnicianInstalationForm from "@/components/technical_support/action_forms/AssignTechnicianInstalationForm.vue";
import AssignTechnicianUninstallationForm from "@/components/technical_support/action_forms/AssignTechnicianUninstallationForm.vue";
import DialogNewInteractionForm from "@/components/interactions/DialogNewInteractionForm.vue";

const DEFAULT_TAB = "0";

export default {
  name: "RequestList",
  components: {
    "request-form": RequestForm,
    "coordinate-installation": CoordinateInstallation,
    "register-diveces": RegisterDevices,
    "record-rating": RecordRating,
    cardcountRequest,
    RequestTypeSelector,
    AssignTechnicianInstalationForm,
    AssignTechnicianUninstallationForm,
    "dialog-new-interaction-form": DialogNewInteractionForm
  },
  data() {
    return {
      confirmLoading: false,
      requestType: null,
      filterDate: [],
      customerList: "",
      Customer_filter: "",
      CustomersFilter: "",
      TechnicianId: "",
      ProductId: "",
      search: "",
      fromDate: "",
      toDate: "",
      asyncComponent: "peity",
      searchResult: [],
      defaultTabActive: DEFAULT_TAB,
      activeName: DEFAULT_TAB,
      columns: COLUMNAS,
      actions: ACTIONS,
      technicians: [],
      dialog: COMMON_DIALOG,
      rules: RULES,
      techniciansLoading: false,
      myRequestInNewCount: 0,
      myRequestInAssingCount: 0,
      myRequestInProgressCount: 0,
      myRequestInClosed: 0,
      myRequestUpdateInventoryCount: 0,
      myRequestUpdateContractCount: 0,
      myRequestValidateCount: 0,
      myRequestQualifyCount: 0,
      myRequestInCancelCount: 0,
      CustomerData: {},
      myRequestInCompleteCount: 0,
      searchLoading: false,

      //  myStarAllCount:0,
      loadingTotalGps: false,
      msg: "",
      productList: [],

      //Assign TechnicianForm DATA
      requestId: 0,
      requestRowData: {},
      selectedTechnician: 0,

      contractDialog: false,
      contractLoading: false,
      savingLoading: false,
      contractList: [],
      ServiceRequestId: 0,
      ClientContractCode: "",
      ClientsContactData: {
        Name: "",
        ContactCode: "",
        PhoneNumber: "",
        MobilePhoneNumber: ""
      },
      ServiceRequestData: {
        Customer: { Name: "", PhoneNumber: "", Address: "" },
        Id: "",
        Comments: "",
        ServiceRequestType: { Description: "" },
        Product: { Description: "" }
      },
      data: [],
      autoLoading: false,
      LineaContrato: "Selecciona un equipo",
      Tracker: "",
      Seriall: "",
      //Telefono: "",
      ruleForm: {
        //Tracker: "",
        //Seriall: "",
        Telefono: ""
      },
      rules2: {
        Telefono: [
          { required: true, message: "Telefono vacio", trigger: "blur" },
          { min: 6, message: "Minimo 6 caracteres", trigger: "blur" }
        ]
      }
      //disabled: true
    };
  },
  watch: {
    defaultTabActive() {
      this.resetCurrent();
      this.filterSearch(this.search);
    }
  },
  methods: {
    formatDate,
    formatArrayToElSelect,
    formatQty,
    ...mapMutations({
      setOriginItems: "rabbey_table/originalItems",
      setLoading: "rabbey_tabs/loading",
      setSuccess: "rabbey_tabs/success",
      setLoadingT: "rabbey_table/loading",
      setSuccessT: "rabbey_table/success",
      setPagination: "rabbey_table/pagination"
    }),
    ...mapActions({
      paginate: "rabbey_table/paginate",
      resetCurrent: "rabbey_table/resetCurrent",
      getTotalGps: "navixy/getTotalGps"
    }),
    ...mapActions({
      fetchCustomers: "customers/getCustomers"
    }),

    //VALIDACION PARA FORM CLOSE INSTALACION Y DESINSTALACION
    /*submitForm(formName) {
      this.confirmLoading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          alert("submit!");
          this.editEquipos();
        } else {
          this.dialog.visible = true;
          this.confirmLoading = false;
         // this.$message.error("probando la vaina");
          return false;
        }
      });
    },*/

    editEquipos() {
      this.$http
        .put("/api/serviceRequests/editequipo", {
          ClienteNo: this.dialog.ClienteNo,
          LineaNo: this.LineaContrato,
          No_Telefono: this.Telefono,
          Id_Tracker: this.Tracker,
          Serial: this.Seriall,
          ContratoNo: this.dialog.ContratoNo
        })
        .then((response) => {
          this.data = response.data;
          //this.$emit("refresh-table");
          //this.$store.commit("deals/EditGoals", response.data);
          //this.handleClosed();
          this.confirmLoading = false;
          this.dialog.visible = false;
          this.$message.success("Equipo actualizado");
        })
        .catch((error) => {
          this.$message.error("Error", error);
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    async handleCommand(c) {
      const { Customer } = c.row;
      this.CustomerData = Customer;

      switch (c.command) {
        case "view": {
          this.$refs.form.draw(c.row.Id);
          break;
        }

        case "assign-technician": {
          this.requestRowData = c.row;
          this.requestId = c.row.Id;
          this.dialog = {
            type: "assign-technician",
            placeholder: "Comentario.",
            title: `Asignar tecnico a la solicitud NO. ${c.row.Id}`,
            visible: true,
            requestId: c.row.Id
          };
          this.actionFormInitialLoad(c.row.ServiceRequestType.Description);
          break;
        }
        case "validate-contract": {
          this.headContractSelect(c.row.ClientCode);
          this.ServiceRequestId = c.row.Id;
          this.ServiceRequestData = c.row;
          this.getContactInformation(c.row.Id);
          this.contractDialog = true;
          break;
        }

        case "cancel": {
          this.dialog = {
            type: "cancel",
            placeholder: "Porfavor ingrese el porque cancelar.",
            title: `Cancelcar Solicitud NO. ${c.row.Id}`,
            visible: true,
            requestId: c.row.Id
          };
          break;
        }

        case "reallocate": {
          this.dialog = {
            type: "reallocate",
            placeholder:
              "Por favor coloque la razón de la edición de la solicitud.",
            title: `Reasignar Solicitud NO. ${c.row.Id}`,
            visible: true,
            requestId: c.row.Id,
            comment: c.row.Comments ? c.row.Comments : ""
          };
          this.dialog.technical = c.row.AssignedTechnicianId;
          this.selectedTechnician = c.row.AssignedTechnicianId;
          this.requestRowData = c.row;
          this.dialog.comment = "";
          this.requestId = c.row.Id;
          this.actionFormInitialLoad(c.row.ServiceRequestType.Description);
          break;
        }

        case "close": {
          await this.KnowIfThereIsTimeToAsign(c.row).then((data) => {
            const isThereTimeToAsign = data;
            // if (this.fileList !== "" && this.fileList !== undefined) {
            //   this.__helperRequestChangeStatus(2, option);
            //   break;
            // }
            if (isThereTimeToAsign === false) {
              this.dialog = {
                type: "close",
                placeholder: "Porfavor ingrese el porque cerrar.",
                title: `Cerrar Solicitud NO. ${c.row.Id}`,
                visible: true,
                requestId: c.row.Id,
                ContratoNo: c.row.ContractCode,
                ClienteNo: c.row.ClientCode,
                TipoSolicitud: c.row.ServiceRequestType.Id,
                TipoProducto: c.row.ProductId
              };

              this.$http
                .get("/api/ServiceRequests/Getinfo", {
                  params: {
                    ContratoNo: this.dialog.ContratoNo,
                    ClienteNo: this.dialog.ClienteNo
                  }
                })
                .then((resp) => {
                  this.data = resp.data;
                });

              /*this.executeAction("/api/serviceRequests/Getinfo",{
                ContratoNo: this.dialog.ContratNo,
                ClienteNo: this.dialog.ClienteNo
              });*/
            } else {
              this.$alert(
                "Aun tiene tareas o solicitudes pendientes de asignarles tiempo, " +
                  "para ello dirijase al reporte de tareas en mis solicitudes o " +
                  "comuniquese con su supervisor para asignarles tiempo.",
                "Tiene Solicitudes o tareas sin tiempo asignado",
                {
                  type: "error"
                }
              );
            }
          });

          break;
        }

        case "reopen": {
          this.dialog = {
            type: "reopen",
            placeholder: "Porfavor ingrese el porque reabir.",
            title: `Reabrir Solicitud NO. ${c.row.Id}`,
            visible: true,
            requestId: c.row.Id
          };
          break;
        }

        case "coordinate_instalation": {
          this.$refs.coordinate_installation.show(c.row);
          break;
        }

        case "register_diveces": {
          this.$refs.register_diveces.show(c.row);
          break;
        }

        case "record_rating": {
          this.$refs.record_rating.show(c.row);
          break;
        }

        case "markContractAsUpdated": {
          this.dialog = {
            type: "markContractAsUpdated",
            placeholder: "Porfavor su comentario.",
            title: `Contrato Actualizado, Solicitud NO. ${c.row.Id}`,
            visible: true,
            requestId: c.row.Id,
            request: c.row
          };

          break;
        }

        case "markInventoryAsUpdated": {
          this.dialog = {
            type: "markInventoryAsUpdated",
            placeholder: "Porfavor su comentario.",
            title: `Inventario Actualizado, Solicitud NO. ${c.row.Id}`,
            visible: true,
            requestId: c.row.Id,
            request: { ...c.row }
          };
          break;
        }

        case "validate": {
          this.dialog = {
            type: "validate", // <<<<<<<<<<<<<<<<<<==============================
            placeholder: "Porfavor su comentario.",
            title: `Inventario Actualizado, Solicitud NO. ${c.row.Id}`,
            visible: true,
            requestId: c.row.Id,
            request: { ...c.row }
          };
          break;
        }

        case "DeviceActivationNavixy": {
          this.dialog = {
            type: "DeviceActivationNavixy",
            placeholder: "Breve Comentario...",
            title: `Activar GPS en la cueta Demo para validar`,
            visible: true,
            RequestId: c.row.Id,
            request: c.row
          };
          break;
        }

        case "DeviceActivationNavixyBridge": {
          this.dialog = {
            type: "DeviceActivationNavixyBridge",
            placeholder: "Breve Comentario....",
            title: `Activar GPS en la cueta del cliente`,
            visible: true,
            RequestId: c.row.Id,
            request: c.row
          };
          break;
        }

        case "new_interaction": {
          this.$refs.dialogNewInteraction.show(c.row.ClientCode);
          break;
        }
        default:
          break;
      }
    },
    cancelDialog(formName) {
      this.confirmLoading = false;
      this.dialog.visible = false;
      this.dialog.technical = "";
      this.dialog.comment = "";
      this.$refs[formName].resetFields();
      this.selectedTechnician = 0;
      this.$refs.InstalationFormData.clearData();
      this.$refs.UninstallationOrDeviceChangeFormData.clearData();
    },
    confirmDialog(formName) {
      this.confirmLoading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmLoading = true;

          switch (this.dialog.type) {
            case "view": {
              break;
            }

            case "assign-technician": {
              ///Dependiendo del tipo de la solicitud este lleva un flujo diferente
              switch (this.requestRowData.ServiceRequestType.Description) {
                case "Instalación": {
                  let instalationdata =
                    this.$refs.InstalationFormData.getFormData();
                  this.executeAction(
                    "/api/serviceRequests/AssignTechinicianAndDevices",
                    {
                      RequestId: instalationdata.RequestId,
                      UserId: this.currentUser.UserID,
                      Request: instalationdata.Request,
                      InstallationRequests:
                        instalationdata.InstallationRequests,
                      LocationCode: instalationdata.LocationCode,
                      Technician: this.dialog.technical,
                      OperationType: 1, //1 = instalacion
                      Comment: this.dialog.comment
                    }
                  );
                  this.$refs.InstalationFormData.clearData();
                  break;
                }

                case "Desinstalación": {
                  var uninstalationList =
                    this.$refs.UninstallationOrDeviceChangeFormData.selectedDevicesList();
                  this.executeAction(
                    "/api/serviceRequests/AssignTechinicianAndDevices",
                    {
                      RequestId: uninstalationList.RequestId,
                      UserId: this.currentUser.UserID,
                      Request: uninstalationList.Request,
                      InstallationRequests:
                        uninstalationList.DesinstalationRequests,
                      LocationCode: uninstalationList.LocationCode,
                      Technician: this.dialog.technical,
                      OperationType: 2, //2 = desinstalacion
                      Comment: this.dialog.comment
                    }
                  );
                  this.$refs.UninstallationOrDeviceChangeFormData.clearData();
                  break;
                }

                case "Cambio de Equipo": {
                  var divecesToChangeList =
                    this.$refs.UninstallationOrDeviceChangeFormData.selectedDevicesList();
                  this.executeAction(
                    "/api/serviceRequests/AssignTechinicianAndDevices",
                    {
                      RequestId: divecesToChangeList.RequestId,
                      UserId: this.currentUser.UserID,
                      Request: divecesToChangeList.Request,
                      InstallationRequests:
                        divecesToChangeList.DesinstalationRequests,
                      LocationCode: divecesToChangeList.LocationCode,
                      Technician: this.dialog.technical,
                      OperationType: 3, //3 = Cambio de Equipo
                      Comment: this.dialog.comment
                    }
                  );
                  break;
                }
                default: {
                  this.executeAction(
                    "/api/serviceRequests/AssignTechinicianAndDevices",
                    {
                      Technician: this.dialog.technical,
                      ProductId: this.ProductId,
                      RequestId: this.dialog.requestId,
                      Comments: this.dialog.comment,
                      UserId: this.$store.state.user.user.UserID
                    }
                  );
                }
              }
              this.dialog.technical = "";
              this.dialog.comment = "";
              break;
            }

            case "cancel": {
              this.executeAction("/api/serviceRequests/cancel", {
                RequestId: this.dialog.requestId,
                UserId: this.$store.state.user.user.UserID,
                Comments: this.dialog.comment
              });
              break;
            }

            case "reallocate": {
              let instalationdata =
                this.$refs.InstalationFormData.getFormData();
              this.executeAction("/api/serviceRequests/ReassignTechnician", {
                TechnicianId: this.dialog.technical,
                ProductId: this.ProductId,
                RequestId: this.dialog.requestId,
                Comments: this.dialog.comment,
                UserId: this.$store.state.user.user.UserID,
                UpdateDeviceList: instalationdata.InstallationRequests
              });
              break;
            }

            case "close": {
              this.executeAction("/api/serviceRequests/close", {
                RequestId: this.dialog.requestId,
                UserId: this.$store.state.user.user.UserID,
                Comments: this.dialog.comment,
                Diagnostic: this.dialog.diagnostic,
                Solution: this.dialog.solution
              }),
                this.editEquipos();
              /*if(this.ruleForm.Telefono != "")
              {
                this.executeAction("/api/serviceRequests/close", {
                RequestId: this.dialog.requestId,
                UserId: this.$store.state.user.user.UserID,
                Comments: this.dialog.comment,
                Diagnostic: this.dialog.diagnostic,
                Solution: this.dialog.solution
              });
              this.submitForm("ruleForm");

              }*/
              break;
            }

            case "reopen": {
              this.executeAction("/api/serviceRequests/reopen", {
                RequestId: this.dialog.requestId,
                UserId: this.$store.state.user.user.UserID,
                Comments: this.dialog.comment
              });
              break;
            }

            case "markContractAsUpdated": {
              this.executeAction("/api/serviceRequests/markContractAsUpdated", {
                RequestId: this.dialog.request.Id,
                UserId: this.currentUser.UserID,
                Comments: this.dialog.comment,
                ContractCode: this.dialog.request.ContactCode,
                CompanyID: this.dialog.request.CompanyCode
              });
              break;
            }

            case "markInventoryAsUpdated": {
              this.executeAction(
                "/api/serviceRequests/markInventoryAsUpdated",
                {
                  RequestId: this.dialog.request.Id,
                  UserId: this.currentUser.UserID,
                  Comments: this.dialog.comment,
                  ContractCode: this.dialog.request.ContactCode,
                  CompanyID: this.dialog.request.CompanyCode
                }
              );
              break;
            }

            case "validate": {
              this.executeAction("/api/serviceRequests/validate", {
                RequestId: this.dialog.request.Id,
                UserId: this.currentUser.UserID,
                Comments: this.dialog.comment,
                ContractCode: this.dialog.request.ContactCode,
                CompanyID: this.dialog.request.CompanyCode
              });
              break;
            }

            case "DeviceActivationNavixy": {
              // this.dialog.comment = "EN DEMO";
              this.executeAction(
                "/api/serviceRequests/DeviceActivationNavixy",
                {
                  requestId: this.dialog.request.Id,
                  activeDeviceInTest: "si",
                  activeDeviceInClient: "",
                  Comments: "EN DEMO"
                }
              );
              break;
            }

            case "DeviceActivationNavixyBridge": {
              this.dialog.comment = "EN CLIENTE";
              this.executeAction(
                "/api/serviceRequests/DeviceActivationNavixyBridge",
                {
                  requestId: this.dialog.request.Id,
                  activeDeviceInTest: "",
                  activeDeviceInClient: "si",
                  Comments: this.dialog.comment
                }
              );
              break;
            }

            default:
              break;
          }
        } else {
          this.dialog.visible = true;
          this.confirmLoading = false;
          this.$message.error("Campos requeridos, accion no realizada!");
          return false;
        }
      });
    },
    executeAction(url, data) {
      this.$http
        .post(url, data, { timeout: 3 * 60 * 1000 })
        .then((resp) => {
          if (url.includes("DeviceActivationNavixy")) this.msg = resp.data;
          else this.msg = "Acción ralizada con éxito";

          this.confirmLoading = false;
          this.dialog.visible = false;
          this.$message({
            type: "success",
            message: this.msg
          });
        })
        // .catch(err => {
        //   this.confirmLoading = false;
        //   this.dialog.visible = false;
        //   this.$message.error(err.message || "Accion fallida.");
        // })
        .finally(() => {
          this.refreshTableSuccess();
          this.confirmLoading = false;
          this.dialog = {
            visible: false,
            requestId: 0,
            comment: "",
            title: "",
            type: "",
            technical: "",
            confirm: {
              loading: false
            },
            request: {}
          };
        });
    },
    handleClose(done) {
      this.$refs.dialogForm.resetFields();
      if (this.dialog.type == "reallocate") {
        this.dialog.technical = "";
        this.dialog.comment = "";
        this.dialog.diagnostic = "";
        this.dialog.solution = "";
        this.$refs.InstalationFormData.clearData();
        this.$refs.UninstallationOrDeviceChangeFormData.clearData();
      }
      this.$refs.InstalationFormData.clearData();
      this.$refs.UninstallationOrDeviceChangeFormData.clearData();
      // this.requestRowData = {
      //   ServiceRequestType: { Description: "" }
      // };
      done();
    },
    onTabSwitch() {
      this.searchResult = [];
    },
    filterSearch(s) {
      this.search = s;
      this.handleFilters();

      if (s.length > 0) {
        if (!isNaN(parseInt(s))) {
          this.setLoading();
          this.searchLoading = true;
          this.$http
            .get(`/api/ServiceRequests`, {
              params: {
                Id: s,
                companyCode: this.currentCompany
              }
            })
            .then((resp) => {
              this.searchLoading = false;
              const items = resp.data.Items;
              const item = items[0];
              // Sino tiene items,muetra mensaje y resetea el tabulador.
              if (!item) {
                this.$message.warning("Solicitud no encontrada");
                this.search = "";
                this.searchResult = [];
                this.$refs.tabs.activeTab = DEFAULT_TAB;
                this.activeName = DEFAULT_TAB;

                this.paginate(PAGINATION_DEFAULT);
                this.setSuccess();
                return;
              }

              this.$refs.tabs.activeTab = `${item.Status}`;
              this.activeName = `${item.Status}`;
              this.defaultTabActive = `${item.Status}`;

              this.searchResult = items;
              this.setOriginItems(items);
              this.paginate(PAGINATION_DEFAULT);
              this.setSuccess();
            })
            .catch((err) => {
              if (err.message.includes("404")) {
                this.$message.warning("Solicitud no encontrada");
              } else {
                this.$alert(err.message, err.name, {
                  type: "error"
                });
              }

              this.search = "";
              this.searchResult = [];
              this.$refs.tabs.activeTab = DEFAULT_TAB;
              this.activeName = DEFAULT_TAB;

              this.paginate(PAGINATION_DEFAULT);
              this.setSuccess();
            });
        } else {
          this.$message.warning("Este campo solo permite numeros");
        }
      } else {
        this.searchResult = [];
        this.$refs.tabs.activeTab = DEFAULT_TAB;
        this.activeName = DEFAULT_TAB;

        this.paginate(PAGINATION_DEFAULT);
      }
    },
    refreshTableSuccess() {
      this.$nextTick(() =>
        this.$refs[`table_${this.defaultTabActive}`].refreshTable()
      );
    },
    __helperFilter(params) {
      // params = { ...params, TechnicianId };
      this.setLoading();
      this.$http
        .get(`/api/ServiceRequests`, {
          params: {
            ...params,
            companyCode: this.currentCompany
          }
        })
        .then((resp) => {
          const items = resp.data.Items;
          const item = items[0];
          // Sino tiene items,muetra mensaje y resetea el tabulador.
          if (!item) {
            this.$message.warning("Solicitud no encontrada");
            this.search = "";
            this.searchResult = [];
            this.$refs.tabs.activeTab = DEFAULT_TAB;
            this.activeName = DEFAULT_TAB;

            this.paginate(PAGINATION_DEFAULT);
            return;
          }

          this.$refs.tabs.activeTab = `${item.Status}`;
          this.activeName = `${item.Status}`;

          this.searchResult = items;
          this.setOriginItems(items);
          this.paginate(PAGINATION_DEFAULT);
        })
        .catch((err) => {
          if (err.message.includes("404")) {
            this.$message.warning("Solicitud no encontrada");
          } else {
            // this.$alert(err.message, err.name, {
            //   type: "error"
            // });
          }

          this.search = "";
          this.searchResult = [];
          this.$refs.tabs.activeTab = DEFAULT_TAB;
          this.activeName = DEFAULT_TAB;

          this.paginate(PAGINATION_DEFAULT);
        })
        .finally(() => {
          this.setSuccess();
        });
    },
    async list_customerservices() {
      await this.$http
        .get(
          `/api/customers/AllCustomerServices?companyCode=${this.currentCompany}`
        )
        .then((resp) => {
          this.customerList = resp.data.map((i) => {
            return {
              Code: i.Code,
              FullName: i.FullName
            };
          });
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    async RequestInNewCount(customerServiceCode = "") {
      await this.$http
        .get(
          `/api/serviceRequests?page=1&skipItems=0&skip=0&limit=10&status=0`,
          {
            params: {
              companyCode: this.currentCompany,
              ServiceRequestTypeId: customerServiceCode,
              TechnicianId:
                this.selectedTechnician != 0 ? this.selectedTechnician : null,
              CustomerService: this.Customer_filter,
              ClientCode: this.CustomersFilter,
              FromDate: this.fromDate,
              ToDate: this.toDate,
              Id: isNaN(parseInt(this.search)) == false ? this.search : null
            }
          }
        )
        .then((resp) => {
          // &CustomerService=${this.Customer_filter === "" ? null : this.Customer_filter}

          this.myRequestInNewCount = resp.data.ItemCount;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    async RequestAssingCount(customerServiceCode = "") {
      await this.$http
        .get(
          `/api/serviceRequests?page=1&skipItems=0&skip=0&limit=10&status=2`,
          {
            params: {
              companyCode: this.currentCompany,
              ServiceRequestTypeId: customerServiceCode,
              TechnicianId:
                this.selectedTechnician != 0 ? this.selectedTechnician : null,
              CustomerService: this.Customer_filter,
              ClientCode: this.CustomersFilter,
              FromDate: this.fromDate,
              ToDate: this.toDate,
              Id: isNaN(parseInt(this.search)) == false ? this.search : null
            }
          }
        )
        .then((resp) => {
          this.myRequestInAssingCount = resp.data.ItemCount;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    async RequestInProgressCount(customerServiceCode = "") {
      await this.$http
        .get(
          `/api/serviceRequests?page=1&skipItems=0&skip=0&limit=10&status=3`,
          {
            params: {
              companyCode: this.currentCompany,
              ServiceRequestTypeId: customerServiceCode,
              TechnicianId:
                this.selectedTechnician != 0 ? this.selectedTechnician : null,
              CustomerService: this.Customer_filter,
              ClientCode: this.CustomersFilter,
              FromDate: this.fromDate,
              ToDate: this.toDate,
              Id: isNaN(parseInt(this.search)) == false ? this.search : null
            }
          }
        )
        .then((resp) => {
          this.myRequestInProgressCount = resp.data.ItemCount;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    async RequestClosedCount(customerServiceCode = "") {
      await this.$http
        .get(
          `/api/serviceRequests?page=1&skipItems=0&skip=0&limit=10&status=4`,
          {
            params: {
              companyCode: this.currentCompany,
              ServiceRequestTypeId: customerServiceCode,
              TechnicianId:
                this.selectedTechnician != 0 ? this.selectedTechnician : null,
              CustomerService: this.Customer_filter,
              ClientCode: this.CustomersFilter,
              FromDate: this.fromDate,
              ToDate: this.toDate,
              Id: isNaN(parseInt(this.search)) == false ? this.search : null
            }
          }
        )
        .then((resp) => {
          this.myRequestInClosed = resp.data.ItemCount;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    async RequestUpdateInventoryCount(customerServiceCode = "") {
      await this.$http
        .get(
          `/api/serviceRequests?page=1&skipItems=0&skip=0&limit=10&status=12`,
          {
            params: {
              companyCode: this.currentCompany,
              ServiceRequestTypeId: customerServiceCode,
              TechnicianId:
                this.selectedTechnician != 0 ? this.selectedTechnician : null,
              CustomerService: this.Customer_filter,
              ClientCode: this.CustomersFilter,
              FromDate: this.fromDate,
              ToDate: this.toDate,
              Id: isNaN(parseInt(this.search)) == false ? this.search : null
            }
          }
        )
        .then((resp) => {
          this.myRequestUpdateInventoryCount = resp.data.ItemCount;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    async RequestUpdateContractCount(customerServiceCode = "") {
      await this.$http
        .get(
          `/api/serviceRequests?page=1&skipItems=0&skip=0&limit=10&status=10`,
          {
            params: {
              companyCode: this.currentCompany,
              ServiceRequestTypeId: customerServiceCode,
              TechnicianId:
                this.selectedTechnician != 0 ? this.selectedTechnician : null,
              CustomerService: this.Customer_filter,
              ClientCode: this.CustomersFilter,
              FromDate: this.fromDate,
              ToDate: this.toDate,
              Id: isNaN(parseInt(this.search)) == false ? this.search : null
            }
          }
        )
        .then((resp) => {
          this.myRequestUpdateContractCount = resp.data.ItemCount;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    async RequestInValidateCount(customerServiceCode = "") {
      await this.$http
        .get(
          `/api/serviceRequests?page=1&skipItems=0&skip=0&limit=10&status=5`,
          {
            params: {
              companyCode: this.currentCompany,
              ServiceRequestTypeId: customerServiceCode,
              TechnicianId:
                this.selectedTechnician != 0 ? this.selectedTechnician : null,
              CustomerService: this.Customer_filter,
              ClientCode: this.CustomersFilter,
              FromDate: this.fromDate,
              ToDate: this.toDate,
              Id: isNaN(parseInt(this.search)) == false ? this.search : null
            }
          }
        )
        .then((resp) => {
          this.myRequestValidateCount = resp.data.ItemCount;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    async RequestInQualifyCount(customerServiceCode = "") {
      await this.$http
        .get(
          `/api/serviceRequests?page=1&skipItems=0&skip=0&limit=10&status=17&ProspectCode=data-pending`,
          {
            params: {
              companyCode: this.currentCompany,
              ServiceRequestTypeId: customerServiceCode,
              TechnicianId:
                this.selectedTechnician != 0 ? this.selectedTechnician : null,
              CustomerService: this.Customer_filter,
              ClientCode: this.CustomersFilter,
              FromDate: this.fromDate,
              ToDate: this.toDate,
              Id: isNaN(parseInt(this.search)) == false ? this.search : null
            }
          }
        )
        .then((resp) => {
          this.myRequestQualifyCount = resp.data.ItemCount;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    async RequestInCancelCount(customerServiceCode = "") {
      await this.$http
        .get(
          `/api/serviceRequests?page=1&skipItems=0&skip=0&limit=10&status=9`,
          {
            params: {
              companyCode: this.currentCompany,
              ServiceRequestTypeId: customerServiceCode,
              TechnicianId:
                this.selectedTechnician != 0 ? this.selectedTechnician : null,
              CustomerService: this.Customer_filter,
              ClientCode: this.CustomersFilter,
              FromDate: this.fromDate,
              ToDate: this.toDate,
              Id: isNaN(parseInt(this.search)) == false ? this.search : null
            }
          }
        )
        .then((resp) => {
          this.myRequestInCancelCount = resp.data.ItemCount;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    async RequestInCompleteCount(customerServiceCode = "") {
      await this.$http
        .get(
          `/api/serviceRequests?page=1&skipItems=0&skip=0&limit=10&status=14`,
          {
            params: {
              companyCode: this.currentCompany,
              ServiceRequestTypeId: customerServiceCode,
              TechnicianId:
                this.selectedTechnician != 0 ? this.selectedTechnician : null,
              CustomerService: this.Customer_filter,
              ClientCode: this.CustomersFilter,
              FromDate: this.fromDate,
              ToDate: this.toDate,
              Id: isNaN(parseInt(this.search)) == false ? this.search : null
            }
          }
        )
        .then((resp) => {
          this.myRequestInCompleteCount = resp.data.ItemCount;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    /*
    async StarAllCount() {



      await this.$http
        .get(
          //`/api/serviceRequests?page=1&skipItems=0&skip=0&limit=100&status=&companyCode=${this.currentCompany}&Valoraciones=1`
          `/api/serviceRequests?page=1&skipItems=0&skip=0&limit=10&status=10&companyCode=${this.currentCompany}`
        )
        .then(resp => {
          let {Items} = resp.data

          Items.forEach(item => {
            if (item.Valoracion == 1) {
              this.myStarAllCount += 1;
            }
          });

        })
        .catch(err => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });

    },
    */
    async GetProductList() {
      await this.$http
        .get("/api/interactions/GetProducts", {
          params: {
            CompanyId: this.currentCompany
          }
        })
        .then((resp) => {
          this.productList = resp.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async handleTechnicianChange(technician) {
      this.selectedTechnician = technician;
      await this.onChangeCustomerService(this.requestType);
    },
    async handleFilters() {
      await this.onChangeCustomerService(this.requestType);
    },
    async handleFilterDate() {
      this.fromDate =
        this.filterDate !== null ? this.filterDate[0] + " 00:00:00" : null;
      this.toDate =
        this.filterDate !== null ? this.filterDate[0] + " 12:59:59" : null;

      await this.onChangeCustomerService(this.requestType);
    },
    actionFormInitialLoad(requestType) {
      switch (requestType) {
        case "Instalación": {
          if (this.$refs.InstalationFormData) {
            this.$refs.InstalationFormData.getCoordinationData();
          }
          break;
        }
        case "Desinstalación": {
          if (this.$refs.UninstallationOrDeviceChangeFormData) {
            this.$refs.UninstallationOrDeviceChangeFormData.getCustomerDevices();
          }
          break;
        }
        case "Cambio de Equipo": {
          if (this.$refs.UninstallationOrDeviceChangeFormData) {
            this.$refs.UninstallationOrDeviceChangeFormData.getCustomerDevices();
          }
          break;
        }
      }
    },
    headContractSelect(clientCode) {
      this.contractLoading = true;
      this.$http
        .get(
          `/api/serviceRequests/headContract?ClientCode=${clientCode}&CompanyCode=${this.currentCompany}`
        )
        .then((resp) => {
          const contracts = resp.data.map((i) => {
            return { ContractCode: i.No_Contrato, Name: i.Nombre };
          });
          this.contractList = contracts;
          this.contractLoading = false;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    LineContractSelect(/*val*/) {
      // this.$http
      //   .get(
      //     `/api/serviceRequests/LineContract?contractNo=${val}&CompanyCode=${this.companyId}`
      //   )
      //   .then(resp => {
      //     //this.$alert(resp.data, 'Result Line Contract');
      //     const contracts = resp.data.map(i => {
      //       return { ContractLineNo: i.LineNo, Description: i.Descripcion };
      //     });
      //     this.LineContract = contracts;
      //     //this.$alert(this.headContractNo, "Result");
      //     // this.$alert(resp.data, "Result");
      //   })
      //   .catch(err => {
      //     this.$alert(err.message, err.name, {
      //       type: "error"
      //     });
      //   });
    },
    handleContractSave() {
      this.savingLoading = true;
      this.$http
        .post(
          `/api/serviceRequests/UpdateContractInServiceRequest?ContractNo=${this.ClientContractCode}&ServiceRequestId=${this.ServiceRequestId}`
        )
        .then(() => {
          this.clearContractDialog();
          this.refreshTableSuccess();
        });
    },
    clearContractDialog() {
      this.contractDialog = false;
      this.contractLoading = false;
      this.savingLoading = false;
      this.contractList = [];
      this.ClientContractCode = "";
      this.ServiceRequestId = 0;
    },
    getContactInformation(serviceRequestId) {
      this.$http
        .get(`/api/serviceRequests/${serviceRequestId}/details`)
        .then((resp) => {
          this.ClientsContactData = resp.data.Contact;
        });
    },
    async onChangeCustomerService(CustomerServiceCode) {
      await this.RequestInNewCount(CustomerServiceCode);
      await this.RequestAssingCount(CustomerServiceCode);
      await this.RequestInProgressCount(CustomerServiceCode);
      await this.RequestClosedCount(CustomerServiceCode);
      await this.RequestUpdateInventoryCount(CustomerServiceCode);
      await this.RequestUpdateContractCount(CustomerServiceCode);
      await this.RequestInValidateCount(CustomerServiceCode);
      await this.RequestInQualifyCount(CustomerServiceCode);
      await this.RequestInCancelCount(CustomerServiceCode);
      await this.RequestInCompleteCount(CustomerServiceCode);
    },
    async KnowIfThereIsTimeToAsign(row) {
      let isThereTimeToAsignPromise = await new Promise((resolve, reject) => {
        // this.loadingData = true;
        this.TasksData = [];
        // await Promise.all(
        this.$http
          .get("/api/ReporteGestion/KnowIfThereAreTasksWithoutTimeAsigned", {
            params: {
              CompanySelected: "TB",
              GerenciaID: null,
              AssignedTechnician: row.AssignedTechnicianId,
              WeekOnMothSelected: null,
              Year: null,
              Month: null,
              closed: false
            }
          })
          .then((response) => {
            //this.loadingData = false;

            resolve(response.data);
          })
          .catch((err) => {
            // this.loadingData = false;
            this.$message.error("Error al cargar los datos de las tareas.");
            reject(err);
          })
          .finally(() => {
            // this.loadingData = false;
          });
      });
      return isThereTimeToAsignPromise;
    },
    async GetTechnicians() {
      this.techniciansLoading = true;
      await this.$http.get("/api/users/technicians").then((resp) => {
        this.technicians = this.formatArrayToElSelect(resp.data, {
          label: "FullName",
          value: "id"
        });
        this.techniciansLoading = false;
      });
    }
  },
  computed: {
    ...mapState({
      pagination: (state) => state.rabbey_table.pagination
      // totalGps: state => state.navixy.total_gps
    }),
    ...mapGetters({
      list_customersSelect: "customers/list_to_select",
      loading_customers: "customers/isLoading"
    }),

    getParams() {
      const activeName = parseInt(this.defaultTabActive);
      let from,
        to = undefined;

      if (this.filterDate !== null) {
        from = this.formatDate(
          new Date(this.filterDate[0]),
          "YYYY-MM-DD 00:00:00"
        );
        to = this.formatDate(
          new Date(this.filterDate[1]),
          "YYYY-MM-DD 12:59:59"
        );
      } else {
        from = undefined;
        to = undefined;
      }

      return {
        Id: isNaN(parseInt(this.search)) == false ? this.search : null,
        TechnicianId: this.TechnicianId,
        ProductId: this.ProductId,
        userID: this.currentUser.UserID,
        status: activeName,
        companyCode: this.currentCompany,
        // Esto es necesario para el filtrado de Pendientes
        ProspectCode: activeName === 17 ? "data-pending" : undefined,
        FromDate: from,
        ToDate: to,
        CustomerService:
          this.Customer_filter === "" ? undefined : this.Customer_filter,
        ServiceRequestTypeId:
          this.requestType === null ? undefined : this.requestType,
        ClientCode:
          this.CustomersFilter === "" ? undefined : this.CustomersFilter
      };
    },
    UninstallAndDeviceChangeValidator() {
      var requestType = this.requestRowData.ServiceRequestType.Description;
      if (
        requestType == "Desinstalación" ||
        requestType == "Cambio de Equipo"
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  async created() {
    await this.fetchCustomers();
    //this.StarAllCount();
    await this.list_customerservices();
    await this.GetProductList();
    await this.GetTechnicians();

    await this.RequestInNewCount();
    await this.RequestAssingCount();
    await this.RequestInProgressCount();
    await this.RequestClosedCount();
    await this.RequestUpdateInventoryCount();
    await this.RequestUpdateContractCount();
    await this.RequestInValidateCount();
    await this.RequestInQualifyCount();
    await this.RequestInCancelCount();
    await this.RequestInCompleteCount();

    if (this.$store.state.interactions.list.length <= 0) {
      this.$store.dispatch("interactions/all");
    }

    if (this.$store.state.interactions.list_interaction_code.length <= 0) {
      this.$store.dispatch("interactions/get_interaction_code");
    }

    if (this.$store.state.products.list.length <= 0) {
      this.$store.dispatch("products/all");
    }

    if (this.$store.state.request_types.list.length <= 0) {
      this.$store.dispatch("request_types/all");
    }
  }
};
</script>

<style scoped>
.demo-input-label {
  display: inline-block;
  width: 130px;
}

.firstinpunt {
  width: 150px;
  padding-left: 10px;
}
</style>
